//variablen muessen pro instanz angepasst werden
module.exports = {
    mantelUrl : 'https://mantel-api.mobile.documedias.systems/v2/conferences/',
    baseUrl: 'https://mantel-api.mobile.documedias.systems/v2/checkall/',
    baseUrlDownload: 'https://mantel-api.mobile.documedias.systems/v2/downloadall/',
    baseUrlCDN: "https://documedias-188ab.kxcdn.com/",
    api_url : 'https://coredev.api.documedias.systems/api/',
    appointment_api_url : '',//'https://dev.appointment.documedias.systems/api/',
    auth_url : 'https://auth.documedias.com/',
    FILE_SERVER_FOLDER : 'b4222936-3c68-408f-8ca4-f0521bfceabd',
    FILE_SERVER_URL : 'https://fileserver.documedias.systems/',
    VUE_APP_X_API_KEY : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRlIjoiMjAyMS0wMi0yNFQxMzowMzoyOC4zMDZaIiwiaWQiOjE1LCJpYXQiOjE2MTQxNzE4MDh9.s5MUeBBlZCyL1kDeegBSUpn7X0FelPnGlGg1pMbxu7c',
    vue_app_access_key : 'eyJhbGciOiJIUzM4NCIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjo5LCJjb25ncmVzc0lkIjoxLCJkYXRlIjoiMjAxOC0xMC0wMVQwOTo0Njo0MC42MDlaIiwiaWF0IjoxNTM4Mzg3MjAwfQ.1Z8vRJF2gZtCuLDEWxQhNyvlYHS6YZsdJxvoYGfyo112afY8CofuEBP4_jvIPXhc',
    cdnInitStamp: "2026-10-08T11:13:00.000Z",//"2025-03-28T16:10:00.000Z"
    conference: '1609',
    short_name: 'dggg2026',
    full_name: 'DGGG 2026',
    api_version: 2, //change this to api version 2 for new conferences!!!
    conf_date : '26 – 30 May',
  auth_key :'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozNjI4LCJjb25ncmVzc0lkIjoxNjA5LCJkYXRlIjoiMjAyNi0wNi0yM1QxMjo1OToyMy44MDBaIiwiaWF0IjoxNzgyMjE5NTYzfQ.CMa8H1xfquYJJUjVA4CXzFFb1ZCnosWH9mziv40N1ZE',
   auth_dev_key : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozNjI4LCJjb25ncmVzc0lkIjoxNjA5LCJkYXRlIjoiMjAyNi0wNi0yM1QxMjo1OToyMy44MDBaIiwiaWF0IjoxNzgyMjE5NTYzfQ.CMa8H1xfquYJJUjVA4CXzFFb1ZCnosWH9mziv40N1ZE',
    auth_dev_key_web : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozNjI4LCJjb25ncmVzc0lkIjoxNjA5LCJkYXRlIjoiMjAyNi0wNi0yM1QxMjo1OToyMy44MDBaIiwiaWF0IjoxNzgyMjE5NTYzfQ.CMa8H1xfquYJJUjVA4CXzFFb1ZCnosWH9mziv40N1ZE',
 // auth_key : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozMjU3LCJjb25ncmVzc0lkIjoxNjU3LCJkYXRlIjoiMjAyNS0xMS0yNlQwOTo0NTowNC44NDVaIiwiaWF0IjoxNzY0MTUwMzA0fQ.EcRkRVcrWsJHEjbP3TIjgm9cZT-MVVOoEvipP9HN6Gc',
 //auth_dev_key : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozMjU3LCJjb25ncmVzc0lkIjoxNjU3LCJkYXRlIjoiMjAyNS0xMS0yNlQwOTo0NTowNC44NDVaIiwiaWF0IjoxNzY0MTUwMzA0fQ.EcRkRVcrWsJHEjbP3TIjgm9cZT-MVVOoEvipP9HN6Gc',
   //auth_dev_key_web : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozMjU3LCJjb25ncmVzc0lkIjoxNjU3LCJkYXRlIjoiMjAyNS0xMS0yNlQwOTo0NTowNC44NDVaIiwiaWF0IjoxNzY0MTUwMzA0fQ.EcRkRVcrWsJHEjbP3TIjgm9cZT-MVVOoEvipP9HN6Gc',
    chat_url: 'https://dggg2026.chat.documedias.systems/api/',
    favorite_api_url: 'https://dggg2026.planner.documedias.systems/api/program/favorites',
    is_multi_conf_app: false, //set true for society or Conf2Go,
    secret_mf:'k3HM1qRe0K+0QX+Eq2JmDV+dTJKnhiQXxu3+7ORwbpA=',
    secret_bluedog: 'ITplW37I+q4g2ZevmHn5x]u0Ayf+oIoMJ6j7ENBar96VI',
    update_user_extra_url : 'https://userextra.cpa.documedias.com',
    main_color: '#c78467',
    is_app: false, //unbedingt anpassen bevor App deploy
    versionIOS:'v1.0 10',
    versionAndroid:'v1.0 10',
    loginRequired: false,
    hasMenuBar:false,
    appdata_version: '_v4',
    database_version: 'v4',

    //enable chat routes and show chat link icon in menu
    chat_enabled: true,
    networking_enabled: true,
    has_menulogo: true, 
    has_recommendations : false,
    //menulogo.png icon in menu bar or just conference name
    interactive_url: 'https://dggg2026.mobile.documedias.com/interactive',
    mediakapsel_url: 'https://dggg2026.documedias.com/mediakapsel2025/',

    // LinkedIn OAuth microservice (see /Users/molinam/gitlab/linkedin-api)
    update_social_url: 'https://auth.documedias.com/api/user/updateSocial',
    linkedin_oauth_url: 'https://linkedin-oauth.documedias.com',
    linkedin_app_return_path: '/linkedin/app-return',
}